import {
  BaseResponseModel,
  PageResponseModel,
  ScheduleModel,
  QueryParamsModel,
  ScheduleGroupByHostModel,
  ISms,
} from './../../shared/';
import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  AuditScheduleModel,
  ScheduleByWeekModel,
  ScheduleFilesAttachment,
  ScheduleTemplateByWeekModel,
} from 'src/app/shared/models/schedule.model';
import { ScheduleTemplateModel } from 'src/app/shared/models/schedule-template.model';

@Injectable()
export class ScheduleService {
  private BASE_URL = environment.base_url;
  constructor(private http: HttpClient) { }

  getAll(
    queryParams: QueryParamsModel
  ): Observable<BaseResponseModel<PageResponseModel<ScheduleModel[]>>> {
    const apiUrl = `${this.BASE_URL}schedules`;
    // tslint:disable-next-line:variable-name
    let _params = new HttpParams()
      // .set('filter', queryParams.filter)
      .set('sortOrder', queryParams.sortOrder)
      .set('sortField', queryParams.sortField)
      .set('index', queryParams.pageNumber.toString())
      .set('pageSize', queryParams.pageSize.toString());
    Object.keys(queryParams.filter).forEach((key) => {
      _params = _params.set(key, queryParams.filter[key]);
    });
    return this.http.get<BaseResponseModel<PageResponseModel<ScheduleModel[]>>>(
      apiUrl,
      { params: _params }
    );
  }

  getAllByWeek(
    queryParams: QueryParamsModel
  ): Observable<BaseResponseModel<ScheduleByWeekModel[]>> {
    const apiUrl = `${this.BASE_URL}schedules/new-version-by-week`;
    // tslint:disable-next-line:variable-name
    let _params = new HttpParams()
      .set('sortOrder', queryParams.sortOrder)
      .set('sortField', queryParams.sortField)
      .set('index', queryParams.pageNumber.toString())
      .set('pageSize', queryParams.pageSize.toString());
    Object.keys(queryParams.filter).forEach((key) => {
      _params = _params.set(key, queryParams.filter[key]);
    });
    return this.http.get<BaseResponseModel<ScheduleByWeekModel[]>>(apiUrl, {
      params: _params,
    });
  }

  getAllTemplateByWeek(
    queryParams: QueryParamsModel
  ): Observable<BaseResponseModel<ScheduleTemplateByWeekModel[]>> {
    const apiUrl = `${this.BASE_URL}schedules-template/new-version-by-week`;
    // tslint:disable-next-line:variable-name
    let _params = new HttpParams()
      .set('sortOrder', queryParams.sortOrder)
      .set('sortField', queryParams.sortField)
      .set('index', queryParams.pageNumber.toString())
      .set('pageSize', queryParams.pageSize.toString());
    Object.keys(queryParams.filter).forEach((key) => {
      _params = _params.set(key, queryParams.filter[key]);
    });
    return this.http.get<BaseResponseModel<ScheduleTemplateByWeekModel[]>>(
      apiUrl,
      {
        params: _params,
      }
    );
  }

  getAllByWeekForFE(
    queryParams: QueryParamsModel
  ): Observable<BaseResponseModel<ScheduleByWeekModel[]>> {
    const apiUrl = `${this.BASE_URL}schedules/new-version-by-week-fe`;
    // tslint:disable-next-line:variable-name
    let _params = new HttpParams()
      .set('sortOrder', queryParams.sortOrder)
      .set('sortField', queryParams.sortField)
      .set('index', queryParams.pageNumber.toString())
      .set('pageSize', queryParams.pageSize.toString());
    Object.keys(queryParams.filter).forEach((key) => {
      _params = _params.set(key, queryParams.filter[key]);
    });

    return this.http.get<BaseResponseModel<ScheduleByWeekModel[]>>(apiUrl, {
      params: _params,
    });
  }

  getAllGroupByHost(
    queryParams: QueryParamsModel
  ): Observable<BaseResponseModel<ScheduleGroupByHostModel[]>> {
    const apiUrl = `${this.BASE_URL}schedules/group`;
    // tslint:disable-next-line:variable-name
    let _params = new HttpParams();
    Object.keys(queryParams.filter).forEach((key) => {
      _params = _params.set(key, queryParams.filter[key]);
    });
    return this.http.get<BaseResponseModel<ScheduleGroupByHostModel[]>>(
      apiUrl,
      { params: _params }
    );
  }

  createSchedule(
    schedule: ScheduleModel
  ): Observable<BaseResponseModel<number>> {
    const apiUrl = `${this.BASE_URL}schedules`;
    return this.http.post<BaseResponseModel<number>>(apiUrl, schedule);
  }

  deleteSchedule(id: number): Observable<BaseResponseModel<string>> {
    const apiUrl = `${this.BASE_URL}schedules/${id}`;
    return this.http.delete<BaseResponseModel<string>>(apiUrl);
  }

  getScheduleById(id: number): Observable<BaseResponseModel<ScheduleModel>> {
    const apiUrl = `${this.BASE_URL}schedules/${id}`;
    return this.http.get<BaseResponseModel<ScheduleModel>>(apiUrl);
  }

  getMessageContent(id: number): Observable<BaseResponseModel<string>> {
    const apiUrl = `${this.BASE_URL}schedules/${id}/message-content`;
    return this.http.get<BaseResponseModel<string>>(apiUrl);
  }

  updateSchedule(
    schedule: ScheduleModel
  ): Observable<BaseResponseModel<number>> {
    const apiUrl = `${this.BASE_URL}schedules`;
    return this.http.put<BaseResponseModel<number>>(apiUrl, schedule);
  }

  updateStatus(id: number): Observable<BaseResponseModel<number>> {
    const apiUrl = `${this.BASE_URL}schedules/update-status/${id}`;
    return this.http.put<BaseResponseModel<number>>(apiUrl, null);
  }

  updateSortOrder(scheduleId: number, sortOrder: number): Observable<BaseResponseModel<number>>{
    const apiUrl = `${this.BASE_URL}schedules/UpdateSortOrder/${scheduleId}/${sortOrder}`;
    return this.http.put<BaseResponseModel<number>>(apiUrl, null);
  }

  approve(scheduleId: number): Observable<BaseResponseModel<number>> {
    const apiUrl = `${this.BASE_URL}schedules/${scheduleId}/approve`;
    return this.http.put<BaseResponseModel<number>>(apiUrl, null);
  }

  pause(schedule: ScheduleModel): Observable<BaseResponseModel<number>> {
    const apiUrl = `${this.BASE_URL}schedules/pause`;
    return this.http.put<BaseResponseModel<number>>(apiUrl, schedule);
  }

  // dời lịch
  change(schedule: ScheduleModel): Observable<BaseResponseModel<number>> {
    console.log(schedule.scheduleDate);
    const apiUrl = `${this.BASE_URL}schedules/change`;
    return this.http.put<BaseResponseModel<number>>(apiUrl, schedule);
  }

  sendSms(body: ISms): Observable<BaseResponseModel<number>> {
    const apiUrl = `${this.BASE_URL}schedules/sms`;
    return this.http.post<BaseResponseModel<number>>(apiUrl, body);
  }

  release(payload: any): Observable<BaseResponseModel<number>> {
    const apiUrl = `${this.BASE_URL}schedules/release`;
    return this.http.post<BaseResponseModel<number>>(apiUrl, payload);
  }

  releaseById(id: number): Observable<BaseResponseModel<number>> {
    const apiUrl = `${this.BASE_URL}schedules/releaseScheduleByScheduleId/${id}`;
    return this.http.post<BaseResponseModel<number>>(apiUrl, {});
  }

  updateMessageContent(payload: any): Observable<BaseResponseModel<number>> {
    const apiUrl = `${this.BASE_URL}schedules/message-content`;
    return this.http.put<BaseResponseModel<number>>(apiUrl, payload);
  }

  copySchedule(id: number): Observable<BaseResponseModel<number>> {
    const apiUrl = `${this.BASE_URL}schedules/${id}/copy`;
    return this.http.post<BaseResponseModel<number>>(apiUrl, null);
  }

  getScheduleHistory(
    scheduleId: number
  ): Observable<BaseResponseModel<AuditScheduleModel[]>> {
    const apiUrl = `${this.BASE_URL}schedules/history/${scheduleId}`;
    return this.http.get<BaseResponseModel<AuditScheduleModel[]>>(apiUrl);
  }

  getAllFilesAttachments(
    scheduleId: number
  ): Observable<BaseResponseModel<ScheduleFilesAttachment[]>> {
    const apiUrl = `${this.BASE_URL}schedules/getAllFilesAttachmentByScheduleId/${scheduleId}`;
    return this.http.get<BaseResponseModel<ScheduleFilesAttachment[]>>(apiUrl);
  }

  getScheduleTemplateById(
    id: number
  ): Observable<BaseResponseModel<ScheduleTemplateModel>> {
    const apiUrl = `${this.BASE_URL}schedules-template/${id}`;
    return this.http.get<BaseResponseModel<ScheduleTemplateModel>>(apiUrl);
  }

  createScheduleTemplate(
    schedule: ScheduleTemplateModel
  ): Observable<BaseResponseModel<number>> {
    const apiUrl = `${this.BASE_URL}schedules-template`;
    return this.http.post<BaseResponseModel<number>>(apiUrl, schedule);
  }

  updateScheduleTemplate(
    schedule: ScheduleTemplateModel
  ): Observable<BaseResponseModel<number>> {
    const apiUrl = `${this.BASE_URL}schedules-template`;
    return this.http.put<BaseResponseModel<number>>(apiUrl, schedule);
  }

  deleteScheduleTemplate(id: number): Observable<BaseResponseModel<string>> {
    const apiUrl = `${this.BASE_URL}schedules-template/${id}`;
    return this.http.delete<BaseResponseModel<string>>(apiUrl);
  }

  getQRCodeByScheduleId(schedId: number): Observable<BaseResponseModel<string>>{
    const apiUrl = `${this.BASE_URL}schedules/GetQRCodeByScheduleId/${schedId}`;
    return this.http.get<BaseResponseModel<string>>(apiUrl);
  }
}
